import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const RejectEmployeeModal = ({show,onClose,rejectReason,setRejectReason,rejectErr,setRejectErr,onSubmit}) => {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Reject Employee</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form.Group>
                    <Form.Label>
                        Reject Reason <span style={{ color: "red" }}>*</span>
                    </Form.Label>

                    <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Enter reject reason..."
                        value={rejectReason}
                        onChange={(e) => {
                            setRejectReason(e.target.value);
                            if (e.target.value.trim() !== "") setRejectErr(false);
                        }}
                    />

                    {rejectErr && (
                        <p className="text-danger mt-1">
                            Reject reason is required
                        </p>
                    )}
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="danger" onClick={onSubmit}>
                    Reject
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RejectEmployeeModal;